/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TrainingRouteImport } from './routes/training'
import { Route as ProcessRouteImport } from './routes/process'
import { Route as AgentsToolingRouteImport } from './routes/agents-tooling'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as IndustriesPharmaceuticalRouteImport } from './routes/industries.pharmaceutical'
import { Route as IndustriesComplianceRouteImport } from './routes/industries.compliance'
import { Route as IndustriesCommercialRealEstateRouteImport } from './routes/industries.commercial-real-estate'

const TrainingRoute = TrainingRouteImport.update({
  id: '/training',
  path: '/training',
  getParentRoute: () => rootRouteImport,
} as any)
const ProcessRoute = ProcessRouteImport.update({
  id: '/process',
  path: '/process',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsToolingRoute = AgentsToolingRouteImport.update({
  id: '/agents-tooling',
  path: '/agents-tooling',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const IndustriesPharmaceuticalRoute =
  IndustriesPharmaceuticalRouteImport.update({
    id: '/industries/pharmaceutical',
    path: '/industries/pharmaceutical',
    getParentRoute: () => rootRouteImport,
  } as any)
const IndustriesComplianceRoute = IndustriesComplianceRouteImport.update({
  id: '/industries/compliance',
  path: '/industries/compliance',
  getParentRoute: () => rootRouteImport,
} as any)
const IndustriesCommercialRealEstateRoute =
  IndustriesCommercialRealEstateRouteImport.update({
    id: '/industries/commercial-real-estate',
    path: '/industries/commercial-real-estate',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/agents-tooling': typeof AgentsToolingRoute
  '/process': typeof ProcessRoute
  '/training': typeof TrainingRoute
  '/industries/commercial-real-estate': typeof IndustriesCommercialRealEstateRoute
  '/industries/compliance': typeof IndustriesComplianceRoute
  '/industries/pharmaceutical': typeof IndustriesPharmaceuticalRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/agents-tooling': typeof AgentsToolingRoute
  '/process': typeof ProcessRoute
  '/training': typeof TrainingRoute
  '/industries/commercial-real-estate': typeof IndustriesCommercialRealEstateRoute
  '/industries/compliance': typeof IndustriesComplianceRoute
  '/industries/pharmaceutical': typeof IndustriesPharmaceuticalRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/agents-tooling': typeof AgentsToolingRoute
  '/process': typeof ProcessRoute
  '/training': typeof TrainingRoute
  '/industries/commercial-real-estate': typeof IndustriesCommercialRealEstateRoute
  '/industries/compliance': typeof IndustriesComplianceRoute
  '/industries/pharmaceutical': typeof IndustriesPharmaceuticalRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/agents-tooling'
    | '/process'
    | '/training'
    | '/industries/commercial-real-estate'
    | '/industries/compliance'
    | '/industries/pharmaceutical'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/agents-tooling'
    | '/process'
    | '/training'
    | '/industries/commercial-real-estate'
    | '/industries/compliance'
    | '/industries/pharmaceutical'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/agents-tooling'
    | '/process'
    | '/training'
    | '/industries/commercial-real-estate'
    | '/industries/compliance'
    | '/industries/pharmaceutical'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AgentsToolingRoute: typeof AgentsToolingRoute
  ProcessRoute: typeof ProcessRoute
  TrainingRoute: typeof TrainingRoute
  IndustriesCommercialRealEstateRoute: typeof IndustriesCommercialRealEstateRoute
  IndustriesComplianceRoute: typeof IndustriesComplianceRoute
  IndustriesPharmaceuticalRoute: typeof IndustriesPharmaceuticalRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/training': {
      id: '/training'
      path: '/training'
      fullPath: '/training'
      preLoaderRoute: typeof TrainingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/process': {
      id: '/process'
      path: '/process'
      fullPath: '/process'
      preLoaderRoute: typeof ProcessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents-tooling': {
      id: '/agents-tooling'
      path: '/agents-tooling'
      fullPath: '/agents-tooling'
      preLoaderRoute: typeof AgentsToolingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/industries/pharmaceutical': {
      id: '/industries/pharmaceutical'
      path: '/industries/pharmaceutical'
      fullPath: '/industries/pharmaceutical'
      preLoaderRoute: typeof IndustriesPharmaceuticalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/industries/compliance': {
      id: '/industries/compliance'
      path: '/industries/compliance'
      fullPath: '/industries/compliance'
      preLoaderRoute: typeof IndustriesComplianceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/industries/commercial-real-estate': {
      id: '/industries/commercial-real-estate'
      path: '/industries/commercial-real-estate'
      fullPath: '/industries/commercial-real-estate'
      preLoaderRoute: typeof IndustriesCommercialRealEstateRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AgentsToolingRoute: AgentsToolingRoute,
  ProcessRoute: ProcessRoute,
  TrainingRoute: TrainingRoute,
  IndustriesCommercialRealEstateRoute: IndustriesCommercialRealEstateRoute,
  IndustriesComplianceRoute: IndustriesComplianceRoute,
  IndustriesPharmaceuticalRoute: IndustriesPharmaceuticalRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
